export default "__VITE_ASSET__506f6577__"